var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286.28,
    height: 259.31,
    enableBackground: "new 0 0 286.278 259.312",
    viewBox: "0 0 286.278 259.312",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m104.5,51.196h-2c.888-3.649-1.766-5.326 0-7 3.073.26 4.497,2.169 7,3 .396,2.396-4.555-.555-3,3l-1.5-.5-.5,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.5,48.196c-.354,1.313-1.761,1.573-2,3-.184.851.39.943 1,1-3.02,2.929-3.92-4.998 1-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.5,155.2c2.693,1.183-.004,5.214 0,7-3.02-1.52.83-4.39 0-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.5,204.2c2.162,1.172 3.828,2.838 5,5-.81-.19-.997-1.003-2-1-1.172.161-.844,1.823-1,3 .04.537-3.882-3.385-5-5 2.64.25 3.28,2.06 3-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.5,208.2c1.383,1.617 4.757,1.243 4,5-.89-.776-2.258-1.075-4-1v-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.5,215.2c-.241,1.759-1.721,2.279-4,2 .66-1.35 2.14-1.87 4-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.5,218.2c4.9-.33-7.94.53 0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.5,221.2c-.85,1.483-2.517,2.15-5,2 .15-2.19 2.52-2.15 5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.5,223.2c-.241,1.759-1.721,2.279-4,2 .66-1.35 2.14-1.87 4-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.5,242.2c-.14,2.86-4.171,1.829-7,2 1.45-1.55 3.9-2.1 7-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.5.196h2c4.526,6.958 3.148,15.41 4,22 .382,2.957 2.035,6.133 2,9-.03,2.453-2.075,4.605-2,7 .115,3.676 4.129,10.174 1,14l-1.167-1.5-1.833.5c-.144-4.857-1.577-8.423-3-12l2-1-2-1c.84-1.161 1.319-2.681 1-5h-1l.5-1.5-.5-1.5c.996-7.662-2.66-10.673-4-16 .805.529 1.623,1.043 3,1 1.973-3.752-.374-7.069-1-11l1.357-1.214-.36-1.786z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.67,65.696 1.833-.5c1.655,2.385-.56,7.583-1,11l-1.5,1.75 .5,2.25h-2c.086,1.419.165,2.832-1,3l-.5-1.5-1.5.5c-5.116-.449-6.945,2.389-11,3l.5-1.5-1.5-.5c-5.684-.316-9.955-2.045-13-5l1.5-1.167-.5-1.833c7.206,3.089 19.77,2.562 26-1 1.126-2.874.202-7.797 2-10l1.17,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.2,93.496 1.3-1.3c11.221,2.446 3.671,23.662 13,28-4.254,11.397 8.609,19.016 9,32l-1.833-.5-1.167,1.5c-5.373-8.627-8.295-19.705-14-28 .649-1.017 2.299-1.034 2-3-.783-4.217-5.636-4.364-7-8 3.206.873 3.128-1.539 4-3-1.65-6.35-3.326-12.674-7-17l1.7-.704z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.29,173.55 1.214-1.357c7.356,5.677 16.229,10.427 16,21l-1.3,1.3-.7,1.7c-2.017-1.316-3.384-3.283-4-6l2-2.25-3,.25c-3.812-5.188-9.155-8.845-12-15l1.79.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278,222.03-.5-1.833c4.178-.844 4.723,1.944 8,2 .17,2.503-1.536,3.131-3,4l-.5-1.5-1.5.5c-.613-1.386-3.85-.15-4-2l1.5-1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281,227.7 1.5-.5c1.752,1.009 5.363,1.729 3,4-3.215,1.119-5.93,2.737-10,3l.5-1.833-1.5-1.167c1.371-2.296 4.118-3.216 6-5l.5,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.8,251.5 1.7.7c-4.046,8.737-10.532-.57-14-4-3.74,2.123-.923,6.928-1,11-4.351.684-5.535-1.799-7-4l1.5-1.167-.5-1.833c2.553-4.256-4.289-7.684-6-11l.5-1.5-.5-1.5c2.979-.354 2.551-4.115 7-3l-.5,1.5 1.5.5v1c5.781,3.553 10.041,8.625 16,12l1.3,1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147,241.36 .5,1.833c-8.29,3.639-14.025-4.643-21-5-4.482-.229-8.532,4.488-13,0l1.5-1.167-.5-1.833c4.239.238 7.921-.079 9-3l1.5.5-.5-1.5c4.845,3.488 10.126,6.54 18,7h1v-1c1.496,1.171 4.09,1.243 5,3l-1.5,1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.667,202.7-1.167,1.5h-2l.5-1.833-1.5-1.167c-4.953-19.334-3.587-47.775-2-79 .572-11.247 2.588-22.757 10-29 5.355-4.511 13.979-6.844 20-10 6.622-3.471 12.802-7.051 21-9 1.422-3.346 1.422-9.654 0-13l1.786.357 1.214-1.357h5c-3.999,3.141 1.465,3.149 2,7l-1.5.5-1.5.5c-2.487.15-.292,3.386 0,4l-1.5.5 .5,1.5h-1c-.007,2.993-1.797,4.203-4,5h-1v1c-.81-.19-.997-1.003-2-1-11.376,6.958-26.541,10.125-35,20l-1.5-.5 .5,1.5c-8.746,1.753-8.575,24.805-9,37-.716,20.565.669,50.992 4,66l-1.833-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.667,52.696-1.167,1.5c-8.139-10.364-11.053-37.094 0-48l.7,1.7 1.3,1.3c-1.144,5.189-4.856,7.811-4,15v1h1c.017,1.464-4.217,3.169 0,3l-.5,1.5 1.5.5c-.111,1.889-3.306.694-3,3 6.338-1.329 9.563-5.77 16-7l1,.5 1-.5v1c1.615.282 1.722-.945 3-1l.5,1.5 1.5-.5c1.817,1.183.786,5.214 2,7-4.705,1.961-5.135,8.198-10,10-2.815-.852-4.103-3.23-8-3-3.516,2.526-1.218,7.636-1,12l-1.833-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.5,23.196v-2c2.48.147 4.853.186 5-2l1.5-1.167-.5-1.833c5.324-.342 8.4-2.933 13-4l1.3,1.3 1.7.7c-4.585,6.081-11.861,9.472-20,12l-1-.5-1-.5v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145,9.696-.5-1.5c1.288-1.424 5.611-3.276 6,0-1.684-.276-.396,8.401-6,3l.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149,36.696 1.5.5c1.004,3.338-1.388,3.279-4,3l-1-.5-1,.5v-4l1.833.5 1.167-1.5c.891-.615 1.788-1.208 2,0l-.5,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.5,148.7 1-.5c2.554,3.113-1.215,12.548 3,14l-.5,1.5 1.5.5c.331,3.664-1.11,5.557-2,8l-1.833-.5-1.167,1.5c-2.275-4.718-3.008-17.036-1-25l1,.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.33,176.7-1.833.5c-1.107-4.226-1.152-9.515-1-15l2.5.5 .5-2.5c4.8-1.867 7.985-5.349 13-7v2.5l2-1.5c1.172.161.844,1.823 1,3l-1.5-.5-.5,1.5c-4.58,3.433-15.999,5.318-12,14 3.869-3.131 7.981-6.019 13-8l.5,1.5 1.5-.5c.776.89 1.075,2.258 1,4l-1.5-.5-.5,1.5c-6.645,1.022-8.553,6.78-15,8l-1.17-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.33,130.7-1.833.5v-4l2.5.5 .5-2.5c4.332-.668 5.372-4.628 10-5l1,1.75 1-1.75c1.172.162.844,1.823 1,3l-1.5.5 .5,1.5c-6.32.013-6.788,5.879-12,7l-1.17-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.67,122.7-1.167,1.5c-2.27-1.064-.381-6.286-1-9l2.1-.1 .9-1.9c3.144,2.85 4.22-2.431 8-2l.9,1.9 2.1.1-1.5.5 .5,1.5c-3.696,1.971-8.023,3.31-9,8l-1.83-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181,172.36-1.5-1.167c1.117-2.323-.215-2.677 2-5l1,.5 1-.5c.81-.19.997-1.003 2-1v1h1c-.803,2.453-1.718,5.767 2,6v1h1c-.19.81-1.003.997-1,2l-2.25-.5-1.75,1.5c-1.987-.013-1.271-2.729-4-2l.5-1.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160,119.7-1.5-.5c-.281-1.615.945-1.722 1-3l1,.5 1-.5c.613-1.386 3.85-.15 4-2l1.5.5 1.5-.5h3l-.071,3.071-.929,2.929c-2.09-.423-2.647.686-4,1l-1.5-.5-1.5.5h-4l.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.33,130.36 .167-2.167h1c.454-2.929 4.729-7.204 6-6-3.788,1.704 2.172,1.646 2,3-2.945,3.054-5.583,6.417-9,9l-1.167-1.5-1.833.5c.083-1.583-.48-3.814 1-4l1.83,1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.67,143.7 1.833-.5c.913.683.959,3.981 1,8l-1.5-.5-.5,1.5h-1l-.5-1.5-1.5.5c-1.336-2.942-.824-6.625 1-9l1.17,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.5,210.2c-2.01-2.656-6.908-2.425-8-6 2.928.261 3.072-2.261 6-2l1.3,1.3 1.7.7c-.19.81-1.003.997-1,2 8.279.721 9.119,8.881 18,9l-.5,1.833 1.5,1.167c-5.393,2.698-13.602-.378-18-2l.5-1.5-1.5-.5v-1l3.25-1.5-3.25-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160,200.03-.5-1.833c3.74-.073 6.913.421 9,2l-1.5,1.167 .5,1.833h-3l-2,.25-1,1.75c-1.352-.981-1.998-2.668-3-4l1.5-1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.5 159.2c1.4 3.63-7.6 3.25 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.02,40.242c-3.271,1.053-7.473.993-11.517,1.955 .575-5.425 5.674-6.326 12-6 0,2.01.2,2.845-.48,4.045z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m123,34.696c.048-.284.095-.568.143-.853 3.885-1.643 8.821-1.045 12.857-.147",
    strokeWidth: 2.9627
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107,52.696c-.643-1-1.22-2-2-3",
    strokeWidth: 1.7321
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.5,52.196c.696.33 1.581.798 2.291,1.319 .617,1.649.759,3.475 1.209,5.181",
    strokeWidth: 1.9014
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.5,58.196c-6.028.716-12.521,2.967-18.5,2.5",
    strokeWidth: 1.8816
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136,64.696c2.373.626 5.977,1.3 8-.5",
    strokeWidth: 2.1004
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.5,166.2c-.543,1.124-.447,2.887-.5,4.5",
    strokeWidth: 1.3416
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201,166.2c1.89-.812 4.002-.383 6-.5",
    strokeWidth: 1.4142
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.5,202.2c.425-.146.912-.124 1.403-.094 1.022,1.926.295,4.375 1.396,6.305 1.053.732 1.845.81 2.701.289",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206,210.7-.503.497c-1.971,4.346 4.53,4.033 4.952,7.588 .711-.04 1.43-.286 2.051-.585",
    strokeWidth: 1.6371
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189,214.2 1.006-.05c.926,2.44 2.912,3.913 4.994,5.55",
    strokeWidth: 2.4054
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195 219.7",
    strokeWidth: 3.0551
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195,219.7c.643-1.059 1.22-1.544 2-2",
    strokeWidth: 1.472
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.67,223.03c-.997.938-1.281,1.737-1.667,2.667",
    strokeWidth: 1.4832
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195 219.7c-1.17 1.77-1.405 2.619-1.333 3.333",
    strokeWidth: 1.7795
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.67,223.03c1.68.229 2.009,2.037 2.934,3.077 3.533-.731.813-5.645-1.601-6.41",
    strokeWidth: 1.5728
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235,217.7c2.108.608 4.213,2.234 5.5,4",
    strokeWidth: 2.5981
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.5,228.2c1.339,1.449 2.326,1.91 3.375,2.068 1.087-1.403 1.606-3.125 3.439-3.484-.054-.532-.245-1.29-.314-2.084",
    strokeWidth: 2.1095
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.5,228.2c3.276-.708 6.493,2.984 5,6",
    strokeWidth: 1.6543
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208,236.7c.677-.467 1.722-.47 2.468-.348 .418,1.121.723,2.501 1.532,3.348",
    strokeWidth: 1.7097
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178,88.696c4.208.092 8.122,2.07 11.2,4.8",
    strokeWidth: 4.0466
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.79,157.84c4.11-.604 4.433,3.485 7.214,5.107",
    strokeWidth: 4.421
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220 162.95c17.54-5.149 35.277-8.899 53-12.25",
    strokeWidth: 3.1344
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220,162.95c.119,4.771 6,6.345 7.286,10.607",
    strokeWidth: 3.7749
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.25 197.95c7.252 5.041 16.15 7.938 24.652 10.437 2.244 3.247 4.622 7.258 4.348 11.313",
    strokeWidth: 3.759
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.25,219.7c.965.974 2.608,1.886 3.75,2.333",
    strokeWidth: 3.7417
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115 237.03c-20.328-8.093-40.969-18.861-56.333-34.333",
    strokeWidth: 3.022
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 216.7c18.611-5.056 37.378-9.226 56-14.333",
    strokeWidth: 3.0846
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.29 61.553c-1.831-3.214-5.655-5.078-6.619-8.857",
    strokeWidth: 3.076
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.2 7.896c11.569-9.239 29.175-9.415 42.6-5.4",
    strokeWidth: 3.7379
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.8,2.496c4.058.138 8.128-2.476 12.058-.514",
    strokeWidth: 3.7933
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120,17.696c.667.04 1.333.184 2,.333",
    strokeWidth: 3.0822
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.8 13.496c2.949-1.346 5.835-3.593 9.2-3.8",
    strokeWidth: 3.0486
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112 67.696c4.884 2.751 9.419 6.088 14 9.333",
    strokeWidth: 2.9488
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.67,65.696c1.296-5.067.239-10.577 3.666-15",
    strokeWidth: 3.7598
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.5 38.196c-3.09 1.383-3.555-3.472-6.5-1.5",
    strokeWidth: 1.8974
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142,51.196c1.316,1.691 4.122,1.267 5.743.233 .95-4.12-1.728-7.839-2.243-11.733",
    strokeWidth: 1.8048
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.33,36.696c-.063-1.043.133-1.957.189-2.792 1.534-2.364 4.858-2.839 7.478-3.208",
    strokeWidth: 2.6667
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.8 2.496c-4.023 4.594-11.036 4.444-15.8 8.2",
    strokeWidth: 1.748
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.5,25.196c2.08-.299 3.398-2.185 5.5-2.5",
    strokeWidth: 1.2153
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.5 23.196c-6.944-2.755-12.971 4.901-19.5 6.5",
    strokeWidth: 1.8425
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116,27.696c.273-.667.391-1.333.5-2",
    strokeWidth: 2.1602
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.5 23.196c-1.138 1.408-3.212 1.9-4 3.5",
    strokeWidth: 1.6733
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133,86.696c1.015-.015 1.886.114 2.75.25",
    strokeWidth: 3.0984
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.75 86.946 3.25-3.25",
    strokeWidth: 2.0817
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.5,79.196c6.085,6.676 11.626,16.369 20.21,19.183 .321-.333.684-.623 1.048-.912 .632-1.347 1.949-2.127 2.575-2.438",
    strokeWidth: 1.6787
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.33,95.03c.934-3.406 4.372-5.127 5.667-8.333",
    strokeWidth: 1.8797
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133 86.696c-8.484-3.98-16.495-8.435-24-14",
    strokeWidth: 1.8379
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65,98.696c15.983,7.606 29.504,25.636 26.454,43.847-.554.561-1.244,1.008-1.704,1.403",
    strokeWidth: 1.7757
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.75,143.95c.574,1.587 1.305,3.133 1.75,4.75",
    strokeWidth: 2.1213
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95 163.7c3.462-6.842 1.7-15.456 3-23",
    strokeWidth: 1.9505
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.833 176.86c1.583 1.187 2.896 1.908 3.738 2.262",
    strokeWidth: 4.7539
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.571 179.12 1.429-1.429",
    strokeWidth: 4.2426
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99,177.7c.357-1 .78-2 1-3",
    strokeWidth: 1.8708
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99 177.7h2",
    strokeWidth: 3.0551
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.571 179.12c-1.056 5.554 4.476 10.23 9.429 11.571",
    strokeWidth: 4.0379
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107 190.7c9.736-4.441 20.595-4.473 30.455-8.637",
    strokeWidth: 3.1555
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.46,182.06c-.521-2.062-.45-3.658-.121-5.363",
    strokeWidth: 3.0938
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.17,151.86c-2.73-3.354-2.762-8.036-.738-11.738",
    strokeWidth: 3.6893
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.43 140.12c-2.832-2.315-2.803-6.164-2.095-9.429",
    strokeWidth: 3.2623
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134,127.7c-.949-1.667-.874-3.333-1.333-5",
    strokeWidth: 3.1885
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.83 99.53c1.699 1.396 2.018 3.78 2.167 5.833",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140 105.36c2.292 1.585 3.579 5.09 2.4 7.733",
    strokeWidth: 2.689
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143,113.7 .984.57c1.311,2.362 1.814,4.934 1.516,7.68",
    strokeWidth: 2.0755
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.17 144.86c2.802 2.838 3.065 7.353 1.333 10.833",
    strokeWidth: 2.136
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.5,177.7c9.054-.577 17.458-4.089 26.5-5.333",
    strokeWidth: 3.2077
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178 88.696c-7.112-4.788-16.415-6.036-24-10.75",
    strokeWidth: 3.2379
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.5,90.196c1.929.5 3.986,1.346 4.5,3.5",
    strokeWidth: 2.7487
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142 93.696c7.274 2.73 7.691-7.31 9-12",
    strokeWidth: 2.0991
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.33,95.03c.938.788 1.737,1.119 2.667,1.667",
    strokeWidth: 2.2361
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130 96.696c2.065-2.723 5.216-4.037 7.5-6.5",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.5,90.196c-.693-1.022-1.276-2.285-1.75-3.25",
    strokeWidth: 2.8284
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178 88.696c-1.461 9.777 5.129 19.657 3 30",
    strokeWidth: 2.1019
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181,118.7 .75,1.5",
    strokeWidth: 2.2361
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.75,120.2c.979-.129 1.842-.609 2.25-1.5",
    strokeWidth: 1.4142
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.75,120.2c-1.264,3.361-.945,6.909.583,10.167",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.25,158.2c.744,2.809-.575,5.994 1.25,8.5",
    strokeWidth: 2.0767
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.5 166.2c2.612-2.006 5.192-4.399 7.5-6.5",
    strokeWidth: 1.2198
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194 163.7c-1.9 3.105-4.328 5.954-5.5 9.5",
    strokeWidth: 1.543
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200 191.2c5.654 1.653 10.594-1.979 15.838-2.927 3.536 1.768 6.374 4.848 10.162 6.427",
    strokeWidth: 2.3274
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226 194.7c2.067-6.899 10.138-3.345 14.5-6.75",
    strokeWidth: 1.633
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.79,157.84c-2.771,2.015-5.87-.115-8.786-.143",
    strokeWidth: 2.5739
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.79,157.84c-.353-2.158-1.577-4.031-2.119-6.143",
    strokeWidth: 3.7639
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130,96.696c.574,2.108 1.549,3.704 3.6,4.6",
    strokeWidth: 1.9685
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.6,101.3c1.627-.442 2.294-1.19 4.233-1.767",
    strokeWidth: 4.7539
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.83 99.53c1.397-1.952 2.281-4.253 4.167-5.833",
    strokeWidth: 3.6056
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.33 230.03c-9.723 1.324-17.245-6.255-26.333-7.333",
    strokeWidth: 1.7265
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126 210.7c-2.295-2.409-5.657-2.133-8.5-3.5",
    strokeWidth: 1.3693
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70,183.7c5.253-.517 10.537-.819 15.5-2.5",
    strokeWidth: 1.6363
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.5 181.2c-1.359-1.577-3.475-2.204-5.5-2",
    strokeWidth: 1.7944
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.5 181.2c2.987-1.064 6.312-1.504 8.333-4.333",
    strokeWidth: 1.6394
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.833,176.86c-.359-1.733-.391-3.521-1.167-5.167",
    strokeWidth: 3.9461
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.75,143.95c-.47-.196-.862-.472-1.25-.75",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.5 143.2c-7.472-2.612-13.804-9.471-17.5-16.5",
    strokeWidth: 1.5191
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.5 143.2c-2.601-7.277-8.218-13.205-13-19",
    strokeWidth: 1.3669
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.6,101.3c-.963,2.128-.714,4.701-.1,6.9",
    strokeWidth: 3.1464
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.5,108.2c2.526.133 4.115-2.359 6.5-2.833",
    strokeWidth: 3.3806
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.5,108.2c-1.412,1.876-1.991,4.711-.9,6.9",
    strokeWidth: 3.5355
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.43,117.27c2.224-1.457 3.456-4.661 2.017-7.018-.647-.384-1.327-.639-1.891-.949-1.486.148-3.45,1.804-4.955,2.995",
    strokeWidth: 2.2978
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.6,112.3c.134.481.312,1.547.4,2.4",
    strokeWidth: 3.4641
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.6,112.3c-1.287-1.031-2.961-1.673-4.534-2.009-.386.274-.849.713-1.28,1.052-.582,1.731-.28,3.57-.285,5.357",
    strokeWidth: 2.0774
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165,120.7c1.141,1.65 3.465,5.026.895,6.385-1.75-1.52-2.8-4.5-.9-6.38",
    strokeWidth: 1.6997
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160,119.7c-.993,1.808-3.898.807-4.405,2.969 6.656,14.539-3.294,47.3 23.072,35.698",
    strokeWidth: 1.9171
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.67,158.36c-1.363-2.342-.048-5.209.333-7.667",
    strokeWidth: 1.7097
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.67,143.7c.637-3.652.649-7.403 1.666-11",
    strokeWidth: 2.7008
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181,118.7c-2.909-.406-6.088,1.448-9-.667",
    strokeWidth: 2.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172 118.03v6.667",
    strokeWidth: 3.0732
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172,118.03-.571-.762",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.43 140.12c4.511-1.411 7.36-5.653 11.738-7.262",
    strokeWidth: 4.325
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.17,132.86c.008-2.844 1.732-7.38-1.167-9.167",
    strokeWidth: 2.6101
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.17 151.86c4.615-1.503 8.152-5.689 13-7",
    strokeWidth: 4.3229
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.17,144.86c2.139-3.868.861-8.892-2-12",
    strokeWidth: 2.5448
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.17,151.86c-1.676,3.373-1.987,7.977.833,10.833",
    strokeWidth: 3.3634
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.67,158.36c.518-.117 1.604-.128 2.583-.167",
    strokeWidth: 2.1213
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.25,158.2c.968-2.333.319-5.119-.25-7.5",
    strokeWidth: 2.4495
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153,165.7c1.117-2.985.404-6.246-1-9",
    strokeWidth: 1.9833
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.46,182.06c5.927-.615 11.558-2.157 17.045-4.363",
    strokeWidth: 3.496
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.5,177.7c1.491-2.793.216-6.134-.5-9",
    strokeWidth: 1.7097
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.8 203.5c3.145-2.604 7.414-3.265 11.367-3.633",
    strokeWidth: 3.9032
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.17,199.86c1.729-2.136 4.745-.428 6.833.166",
    strokeWidth: 3.0748
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167 201.36c11.498 2.018 24.706-2.121 33-10.167",
    strokeWidth: 3.3477
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200 191.2c-4.986-5.137-10.498-9.952-13.75-16.5",
    strokeWidth: 3.8028
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107 190.7c4.565 10.091 18.997 8.423 23.6 17.4",
    strokeWidth: 3.3003
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.6 208.1c4.997 1.578 9.723 3.962 15.15 3.6",
    strokeWidth: 2.3313
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.25 207.45c2.761 1.939 3.41 6.168 6.964 7.107",
    strokeWidth: 3.0277
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.21 214.55c5.546-2.227 13.155 1.74 15.842 6.602-2.078 2.811-6.563 1.256-9.556 2.541",
    strokeWidth: 3.3019
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182,231.2c3.995,3.462 10.049-.932 13.711,2.599 .03,1.068-.902,2.031-1.711,2.901",
    strokeWidth: 3.1623
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.8 251.5c16.136-20.315 43.648-6.429 63.2-19.133",
    strokeWidth: 3.519
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281,227.7c.321-1 .61-2 1-3",
    strokeWidth: 2.1602
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226 194.7c2.431 3.242 5.89 6.255 10 7",
    strokeWidth: 2.1764
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236 201.7c2.32-2.878 5.942-2.86 9.25-3.75",
    strokeWidth: 2.582
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.25,197.95c-.189-.854-1.046-2.464-2.05-3.45",
    strokeWidth: 4.219
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.17 199.86c2.508 3.086 4.051 6.948 7.166 9.5",
    strokeWidth: 2.0292
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.33,209.36c1.194-.862 2.737-1.028 3.917-1.917",
    strokeWidth: 1.9149
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.25,207.45c-.73-1.688-1.259-2.938-1.75-4",
    strokeWidth: 3.0551
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236,201.7c3.51,6.857 4.223,16.755 14.255,17.693 4.917-.059 6.192,6.393 11.058,6.756 1.085.1 2.536-.845 3.028-1.51 .189-2.307-1.648-4.188-1.704-6.485",
    strokeWidth: 3.1647
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.64 218.15c-2.06-2.31-4.318-4.501-6.97-6.121",
    strokeWidth: 2.8636
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.64 218.15c4.033-1.182 7.473 2.372 11.613 1.546",
    strokeWidth: 2.6141
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163 216.36c7.261 3.862 7.846 19.457 19 14.833",
    strokeWidth: 2.317
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182 231.2c-1.428-2.536-4.152-4.406-4.5-7.5",
    strokeWidth: 3.2249
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.33,209.36c-.023,2.675 3.295,4.054 2.667,7",
    strokeWidth: 2.2156
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.6 208.1c-1.433 1.022-2.99 1.88-4.6 2.6",
    strokeWidth: 2.4238
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126 210.7c-4.711 5.281-6.409 12.773-3.667 19.333",
    strokeWidth: 1.6667
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.33 230.03 2.667 2.667",
    strokeWidth: 1.633
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.21,214.55c.782,3.721 3.023,7.121 6.286,9.143",
    strokeWidth: 3.2404
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147 241.36c13.258 4.696 24.721 17.46 39.5 9.333",
    strokeWidth: 3.6754
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.5,250.7c.739-2.602-.509-5.326-2.5-7",
    strokeWidth: 2.2583
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184,243.7c-.497.729-.854,1.218-1.202,1.694-2.822.323-5.655.827-8.298,1.806",
    strokeWidth: 1.5811
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184,243.7c-.03-.637-.138-1.195-.25-1.75",
    strokeWidth: 3.0822
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.75,241.95c-3.045-.604-5.551-2.875-8.75-3.25",
    strokeWidth: 2.3136
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.75 241.95c1.161-1.292 2.657-1.987 4.25-2.25",
    strokeWidth: 2.5249
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163,216.36c-1,.214-2,.406-3,.666",
    strokeWidth: 3.2404
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144,214.7c-8.87,4.582-8.395,18.365-.5,23.5",
    strokeWidth: 1.9166
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.5,250.7c2.651.806 4.978,2.21 7.5,3.333",
    strokeWidth: 3.3029
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135,42.696c1.318-.591 1.911-1.634 3-2",
    strokeWidth: 1.2111
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.5 138.2c3.207 2.435 6.386 5.14 9.5 7.5",
    strokeWidth: 1.3765
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.5 189.2c4.344-1.94 8.859-3.556 13.5-4.5",
    strokeWidth: 1.4268
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.a85fe22952787bee44f186ac93b95cd0.svg";
export { ForwardRef as ReactComponent };